import api from '../../api'
import { ResolvedTaxRateLocation } from '../../../domain/invoicing/resolvedTaxRateApi'

export const wrongJurisdictionInvoicesEndpoint = '/web/admin/invoicing/wrong-jurisdiction-invoices'

export type WrongJurisdictionInvoice = {
  tenantId: number
  tenantName: string
  invoiceId: string
  invoiceNumber: string
  createdAt: string
  appliedRate: number
  resolvedLocation: ResolvedTaxRateLocation | null
  propertyLocation: ResolvedTaxRateLocation | null
}

export const getWrongJurisdictionInvoices = async (): Promise<WrongJurisdictionInvoice[]> => {
  return (await api.get(wrongJurisdictionInvoicesEndpoint)).data
}
